<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="房型名称:"
                      prop="name">
          <el-input v-model.trim="searchForm.name"
                    placeholder="房型名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/room_type/add'"
                 type="primary"
                 @click="handleAdd">新增</el-button>
      <el-button v-has="'/room_type/batch_del'"
                 type="primary"
                 @click="multipleDelete">批量删除</el-button>
      <!-- <el-button type="primary"
                 @click="handleExport">导 出</el-button> -->
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="80"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'picture' && scope.row[item.prop]">
              <el-image style="width: 40px; height: 40px"
                        :src="imgDownUrl + scope.row.picture"
                        fit="fill"
                        :preview-src-list="[imgDownUrl + scope.row.picture]">
              </el-image>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button v-has="'/room_type/edit'"
                       size="mini"
                       type="primary"
                       @click="handleEdit(scope.row)">编辑</el-button>
            <el-button v-has="'/room_type/batch_del'"
                       size="mini"
                       type="danger"
                       @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <add-hosehold v-if="showHouseholdModal"
                  :isShow="showHouseholdModal"
                  :data="hoseholdData"
                  @handleClose="closeHouseholdModal"></add-hosehold>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import AddHosehold from '@/views/basic/household/AddHosehold'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { AddHosehold, Pagination },
  data() {
    return {
      imgDownUrl: fetch.downImgUrl,
      searchForm: {
        name: '',
        type: ''
      },
      tableTitle: [
        {
          prop: 'name',
          name: '房型名称',
          width: '100'
        },
        {
          prop: 'picture',
          name: '示意图',
          width: '80'
        },
        {
          prop: 'room_type_bed',
          name: '床位',
          width: '200'
        },
        {
          prop: 'room_type_facilities',
          name: '设施',
          width: '200'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加房型相关
      showHouseholdModal: false,
      hoseholdData: {
        type: 'add'
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getRoomTypeList({
          perPage: perPage,
          currentPage: currentPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 添加假日管理
    handleAdd() {
      this.showHouseholdModal = true
      this.hoseholdData = {
        type: 'add'
      }
    },
    // 批量删除
    multipleDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.delRoomType(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择房型后重试')
      }
    },
    // 导出
    handleExport() {},
    // 编辑
    handleEdit(data) {
      this.showHouseholdModal = true
      this.hoseholdData = {
        type: 'edit',
        id: data.id
      }
    },
    closeHouseholdModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showHouseholdModal = false
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delRoomType(data.id)
        })
        .catch(() => {})
    },
    // 删除房型
    delRoomType(ids) {
      fetch.batchDelRoomType({ id: ids }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.getList()
            this.$message.success('操作成功')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style></style>
